/**
 * Valida che il target di redirect post-login sia un path interno relativo,
 * per prevenire open redirect quando il valore arriva da un query param
 * controllabile dall'utente (es. ?appState={"target":"..."}).
 *
 * Un attaccante potrebbe costruire un link di login con un appState del tipo
 * {"target":"https://sito-malevolo.com"} oppure {"target":"//sito-malevolo.com"}
 * (protocol-relative). In entrambi i casi il browser seguirebbe il redirect
 * fuori dall'app se il valore non viene validato prima di navigateByUrl().
 *
 * Regola: il target è considerato sicuro solo se inizia con un singolo "/"
 * e NON con "//" o "/\" (che alcuni browser normalizzano come protocol-relative
 * URL, trattandolo quindi come assoluto).
 */
export function isSafeInternalTarget(target: unknown): target is string {
  if (typeof target !== "string" || target.length === 0) {
    return false;
  }
  if (!target.startsWith("/")) {
    return false;
  }
  if (target.startsWith("//") || target.startsWith("/\\")) {
    return false;
  }
  return true;
}